// extracted by mini-css-extract-plugin
export default {"title":"BladeSection_title__gb6ez","titleRow":"BladeSection_titleRow__DA5Qc","clearBtn":"BladeSection_clearBtn__BHJMF"};